/**
 * RelatedDocumentsModal.js
 * Created by Ajit on 10/15/2020.
 */
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import TabBar from '../../Tabs/TabBar';
import {labels, currentResource} from '../../../../util/utils';
import RelateItemList from '../../RelateList/RelateItemList';
import Ellipses from '../../EllipsesControl/EllipsesControl';
import Button from '../../BaseComponentWrappers/MotifButton';
import {
	relatedDocumentsTab,
	documentSearchTypes,
	documentCategoryNames,
	relateDocumentsTo,
	documentTabLayoutTabs,
	pagingOptions,
	clientSideEventNames
} from '../../../../util/uiconstants';
import {updateFormBodyRelatedDocCount} from '../../../../actions/FormData/formdataactions';
import RelateDocuments from '../../RelateDocuments/RelateDocuments';
import RelatedDocumentsItem from '../../CanvasForm/Common/RelatedDocumentsItem';
import Modal from '../../Modal/Modal';
import FileUpload440GLControl from '../../FileUpload/FileUpload440GLControl';
import {useTaskId, useUserPreferences} from '../../../../util/customHooks';
import {getAllRelatedDocuments} from '../../../../actions/FormBodyRelatedDocuments/formbodyrelateddocumentsactions';

export default function RelatedDocumentsModal(props) {
	const {
		engagementId,
		documentId,
		bodyId,
		show,
		title,
		onHide,
		closeTitle,
		modalsize,
		modalbodystyle,
		relatedDocActiveTab,
		isTargetEng,
		isAresView,
		documentCount,
		setDocumentCount,
		listHeaders,
		isModalOpen
	} = props;

	const [tabName, setTabName] = useState(relatedDocActiveTab || relatedDocumentsTab.EVIDENCE),
		[searchText, setSearchText] = useState(''),
		[pageSize, setPageSize] = useState(pagingOptions.defaultPageSize),
		[page, setPage] = useState(1),
		[resetPaging, setResetPaging] = useState(0),
		[showRelateDocumentsModal, setShowRelateDocumentsModal] = useState(false),
		[bodyToUpdate, setBodyToUpdate] = useState(0),
		[updateReferenceDocCount, setUpdateReferenceDocCount] = useState(false);
	const isInitialized = useRef(false);
	const [isCheckoutCheckinEventDispatched, setIsCheckoutCheckinEventDispatched] = useState(false);
	let parentName =
			tabName === relatedDocumentsTab.EVIDENCE
				? documentTabLayoutTabs.evidenceName
				: documentTabLayoutTabs.priorPeriodName,
		targetEngagementId = isTargetEng ? engagementId : null;

	const userPreferences = useUserPreferences();

	const formBodyRelatedDocuments = useSelector((store) => {
		return store.formBodyRelatedDocuments[bodyId];
	});

	const dispatch = useDispatch();

	const onTabChange = useCallback((tabName) => {
		setTabName(tabName);
		isInitialized.current = false;
	}, []);

	const fetchDocuments = useCallback(
		(_, __, ___, ____, _____) => {
			if (!isInitialized.current) {
				isInitialized.current = true;
			}
			return getDocuments();
		},
		[tabName, engagementId, documentId, bodyId, isCheckoutCheckinEventDispatched, searchText, page, pageSize]
	);

	const getDocuments = () => {
		let includeReviewNotes = true;

		if (tabName === relatedDocumentsTab.EVIDENCE) {
			return dispatch(
				getAllRelatedDocuments(
					engagementId,
					targetEngagementId,
					documentId,
					bodyId,
					bodyId,
					documentSearchTypes.canvasFormbody,
					documentCategoryNames.canvasFormBodyEvidence,
					true,
					pageSize,
					page,
					searchText,
					includeReviewNotes
				)
			);
		} else if (tabName === relatedDocumentsTab.PRIOR_PERIOD) {
			includeReviewNotes = false;

			return dispatch(
				getAllRelatedDocuments(
					engagementId,
					targetEngagementId,
					documentId,
					bodyId,
					bodyId,
					documentSearchTypes.canvasFormbody,
					documentCategoryNames.priorPeriod,
					true,
					pageSize,
					page,
					searchText,
					includeReviewNotes
				)
			);
		}
	};

	const onSearch = (value) => {
		setSearchText(value);
		setPage(1);
	};

	const onModalClose = () => {
		onHide();
	};

	const onRelateDocumentsModalClose = () => {
		setShowRelateDocumentsModal(false);
		setUpdateReferenceDocCount(true);
		setBodyToUpdate(bodyId);
	};

	const onClickAddEvidence = () => {
		dispatch(
			getAllRelatedDocuments(
				engagementId,
				targetEngagementId,
				documentId,
				bodyId,
				bodyId,
				documentSearchTypes.canvasFormbody,
				documentCategoryNames.canvasFormBodyEvidence,
				true,
				-1,
				0,
				'',
				false
			)
		).then(() => {
			setShowRelateDocumentsModal(true);
		});
	};

	let evidenceCount;
	let priorPeriodCount;
	if (tabName === relatedDocumentsTab.EVIDENCE) {
		evidenceCount = formBodyRelatedDocuments?.totalEntityCount;
	} else if (tabName === relatedDocumentsTab.PRIOR_PERIOD) {
		priorPeriodCount = formBodyRelatedDocuments?.totalEntityCount;
	}
	const tabs = [
		{id: relatedDocumentsTab.EVIDENCE, label: labels.evidence, value: evidenceCount},
		{id: relatedDocumentsTab.PRIOR_PERIOD, label: labels.priorPeriodEvidence, value: priorPeriodCount}
	];

	const headerRender = () => (
		<StyledListHeader className="StyledListHeader">
			<section className="relateDocumentsBodyConatiner">
				<section className="relateDocumentsBodyWrapper">
					{tabName === relatedDocumentsTab.EVIDENCE ? (
						!isTargetEng &&
						!userPreferences.isGuestUser &&
						!userPreferences.isCEAPUser &&
						tabName === relatedDocumentsTab.EVIDENCE && (
							<Ellipses
								content={labels.viewEvidenceRelatedToBody}
								tooltip={labels.viewEvidenceRelatedToBody}
								noOfLines={2}
							/>
						)
					) : (
						<Ellipses
							content={labels.priorPeriodEvidencesToTheBody}
							tooltip={labels.priorPeriodEvidencesToTheBody}
							noOfLines={2}
						/>
					)}
				</section>
				{!isTargetEng &&
					!userPreferences.isGuestUser &&
					!userPreferences.isCEAPUser &&
					!isAresView &&
					tabName === relatedDocumentsTab.EVIDENCE && (
						<section className="addEvidenceButton">
							<Button
								onClick={onClickAddEvidence}
								type="button"
								variant="primary"
								className=""
								showLabel
								buttonLabel={labels.addEvidence}
							/>
						</section>
					)}
			</section>
			<TabBar badge activeTab={tabName} tabs={tabs} styleName="refDocModalTabs" onTabChange={onTabChange} />
		</StyledListHeader>
	);

	const itemComponent = useCallback((document) => {
		return (
			<RelatedDocumentsItem
				loadRelatedDocuments={fetchDocuments}
				document={document}
				documentId={documentId}
				userPreferences={userPreferences}
				bodyId={bodyId}
				entityUId={bodyId}
				isTargetEng={isTargetEng}
				setUpdateReferenceDocCount={setUpdateReferenceDocCount}
				setBodyToUpdate={setBodyToUpdate}
				parentName={parentName}
				showNotes={!isAresView}
				showSignOffs={!isAresView}
				isModalOpen={true}
				isAresView={isAresView}
				isFromRelatedDocumentsModal
			/>
		);
	}, []);

	const configuration = useMemo(
		() => ({
			checkBox: false,
			noResultsLabel: labels.noRelatedDocuments,
			data: fetchDocuments,
			render: itemComponent
		}),
		[fetchDocuments, itemComponent, bodyToUpdate]
	);

	useEffect(() => {
		if (show && tabName !== undefined) {
			setResetPaging(resetPaging + 1);
		}
	}, [show, bodyId]);

	useEffect(() => {
		if (formBodyRelatedDocuments) {
			if (bodyToUpdate === bodyId && updateReferenceDocCount === true) {
				dispatch(updateFormBodyRelatedDocCount(bodyId, formBodyRelatedDocuments?.totalEntityCount)).then(() => {
					setBodyToUpdate(0);
					setUpdateReferenceDocCount(false);
				});
			}
		}
	}, [formBodyRelatedDocuments]);

	const handleCheckoutCheckin = useCallback(() => {
		setIsCheckoutCheckinEventDispatched((state) => !state);
	});

	useEffect(() => {
		window.addEventListener(clientSideEventNames.checkoutCheckin, handleCheckoutCheckin);
		return () => {
			window.removeEventListener(clientSideEventNames.checkoutCheckin, handleCheckoutCheckin);
		};
	}, [handleCheckoutCheckin]);

	return (
		<>
			<Modal
				show={show}
				onHide={onModalClose}
				modalsize={modalsize}
				closeBtnTitle={closeTitle}
				closeTitle={closeTitle}
				modalbodystyle={modalbodystyle}
				styleName="relatedDocumentModalMedium"
				showButtons={false}
				showFooter={false}
				title={title}
			>
				<StyledRelatedDocumentModalWrapper className="StyledRelatedDocumentModalWrapper">
					<RelateItemList
						componentHeader={headerRender}
						listHeaders={listHeaders}
						search
						onSearch={onSearch}
						pagination
						showSelectedOnlyCheckBox={false}
						searchPlaceholder={labels.searchDocuments}
						searchClearHoverText={labels.clearHoverText}
						noResultsLabel={labels.noResultFound}
						paginationIconHover={currentResource.pagingSvgHoverText}
						paginationShowText={labels.pagingShowtext}
						configuration={configuration}
						showAddedLabel
						addedLabel={labels.pinned}
						page={page}
						pageSize={pageSize}
						onPageChanged={(page) => {
							setPage(page);
						}}
						onPageSizeChanged={(pageSize, searchString) => {
							setPage(1);
							setSearchText(searchString);
							setPageSize(pageSize);
						}}
					/>
				</StyledRelatedDocumentModalWrapper>
			</Modal>
			{showRelateDocumentsModal && (
				<>
					<RelateDocuments
						relatedDocumentsList={formBodyRelatedDocuments}
						engagementId={engagementId}
						documentId={documentId}
						showModal={showRelateDocumentsModal}
						onClose={onRelateDocumentsModalClose}
						comingFrom={relateDocumentsTo.canvasFormBody}
						entityUid={bodyId}
						isAresView={isAresView}
						tabName={tabName}
						documentCount={documentCount}
						setDocumentCount={setDocumentCount}
						getRelatedDocuments={getDocuments}
					/>
					<FileUpload440GLControl
						documentsData={formBodyRelatedDocuments}
						parentName={documentTabLayoutTabs.evidenceName}
					/>
				</>
			)}
		</>
	);
}

const StyledRelatedDocumentModalWrapper = styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	position: relative;
	.relate-list-loading-indicator {
		position: absolute !important;
		width: 100%;
		border: 0;
		z-index: 2;
	}
	.StyledRelateItemsListHeader {
		padding-bottom: 0;
		border: 0;
		.RelateItemsListHeaderComponent {
			width: 100% !important;
			margin-right: 0 !important;
		}
	}
	.relate-list-body-wrapper {
		.RelateItemListItem {
			.relate-item-list-item {
				padding: 0;
				.relate-item-list-labelTxt {
					width: 100%;
					.relatedDocumentsItemWrapperContainer {
						.relatedDocuments__row {
							overflow: hidden;
							.relatedDocumentDocName {
								width: 100% !important;
							}
							.body-quick-reference__row__sign-offs {
								width: var(--px-240);
							}
						}
					}
				}
			}
		}
	}
	.addEvidenceButton {
		float: right;
		margin-left: auto;
	}
	.RelateListColumnHeadersContainer {
		padding: 0 !important;
		border-bottom: 0;
		.relatedDocuments__header {
			display: flex;
			background: var(--neutrals-25);
			color: var(--neutrals-900);
			border-bottom: var(--px-1) solid var(--neutrals-300);
			padding: var(--px-14) 0 var(--px-14) var(--px-16);
			font-size: var(--px-14);
			height: var(--px-48);
			align-items: center;
			border-radius: var(--px-8) var(--px-8) 0 0;
			.relatedDocumentsHeaderName {
				flex: 1 1 0;
				display: flex;
				width: calc(100% - var(--px-310));
				font-size: var(--px-14);
				font-weight: 400;
				line-height: var(--px-20);
				color: var(--neutrals-900);
				&.removeBtn {
					max-width: 6rem;
					width: auto;
					padding-right: var(--px-16);
					flex: 0 0 auto;
					justify-content: flex-end;
					.StyledEllipse {
						width: auto;
					}
				}
			}
			.relatedDocumentsHeaderNotes {
				width: var(--px-70);
				font-size: var(--px-14);
				font-weight: bold;
				display: flex;
				justify-content: center;
				.ellipses {
					width: auto;
				}
			}
			.relatedDocumentsHeaderSignoff {
				width: var(--px-240);
				padding-left: var(--px-20);
				font-size: var(--px-14);
				font-weight: bold;
				display: flex;
				justify-content: flex-start;
				.ellipses {
					width: auto;
				}
			}
			.relatedDocumentsHeaderRelatedTasks {
				width: var(--px-100);
				font-size: var(--px-14);
				font-weight: bold;
				display: flex;
				justify-content: center;
				.ellipses {
					width: auto;
				}
			}
			div {
				display: block !important;
			}
		}
	}
`;

const StyledRefDocModal = styled.section`
	.DocumentNameWrapper {
		display: inline-flex;
		.DocumentName {
			display: inline-flex !important;
			align-items: center !important;
			max-width: 55vw;
		}
		.documentName-icons {
			.StyledDisplayDocumentSignoffRequirements {
				margin-bottom: 0;
			}
		}
	}
`;

const StyledListHeader = styled.section`
	padding-bottom: 0;
	width: 100%;
	display: flex;
	font-size: var(--px-14);
	line-height: normal;
	flex-direction: column;
	.relateDocumentsBodyConatiner {
		display: flex;
		align-items: center;
		margin-bottom: var(--px-24);
		.relateDocumentsBodyWrapper {
			flex: 1;
			font-size: var(--px-16);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
		}
	}
	.refDocModalTabs {
		.motif-tab-navigation {
			width: 100%;
			.motif-tab-button {
				.tabBarItemWrapper {
					display: flex;
					.StyledEllipse {
						width: auto;
					}
				}
			}
		}
	}
	.instructional-text {
		font-size: var(--px-15);
		line-height: normal;
		padding-bottom: var(--px-20);
	}
`;
